import { MIN_CHAR_LENGTH_IN_SEARCH } from "@/components/Search/constants";
import useTableDataFunctions from "@/components/Table/hooks/useTableDataFunctions";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import { ROUTES } from "../../types";

const useApiQueryParams = (pageLocation: ROUTES) => {
  const { pagination, params } = useTableStoreByRoute(pageLocation);

  const { getFiltersAndFormFilterQueryParams } = useTableDataFunctions();

  const pageToShow = pagination.page.toString();
  const rowsCount = pagination.pageSize;
  const filterParams = params.filters;
  const sortedColumn = params.sortedColumn;
  const searchParams = params.contains;

  const getApiQueryParams = () => {
    if (pageLocation === ROUTES.Dashboard || pageLocation === ROUTES.Home) {
      return pageLocation;
    }

    const searchQueryString =
      searchParams && searchParams.length >= MIN_CHAR_LENGTH_IN_SEARCH
        ? `&Contains=${encodeURIComponent(searchParams)}`
        : "";

    const sortingString = sortedColumn
      ? `&OrderBy=${sortedColumn.orderBy}&Descending=${sortedColumn.descending}`
      : "";

    const baseQuery = `${pageLocation}?PageNumber=${pageToShow}&PageSize=${rowsCount}${searchQueryString}${sortingString}`;

    const apiQueryParams =
      baseQuery + getFiltersAndFormFilterQueryParams(filterParams);

    return apiQueryParams;
  };

  return { getApiQueryParams };
};

export default useApiQueryParams;
